import loadSd from 'functions/loadSD'
import { DesignerGeoType } from 'components/Designer/Types'

const initGeoData = async (geo: DesignerGeoType[]) => {
  if (geo) {
    const data = []
    for (let model of geo) {
      let sdm_model,
        model_uuid = null
      if (model.model) {
        sdm_model = await loadSd(`${model.model}`)
        model_uuid = Object.keys(sdm_model.structure)[0]
      }
      data.push({
        datatype: sdm_model.filetype as string,
        version: sdm_model.version as string,
        uuid: model_uuid as string,
        data: sdm_model as {} | null,
        baked: model.baked as string | null,
        // mediaPath: mediaPath,
        images: model.img as string[],
      })
    }
    return data
  }
  return
}

export default initGeoData
